import { useVersionCheck } from '../hooks/useVersionCheck';
import UpdateBanner from '../components/UpdateBanner';
import { useChunkErrorHandler } from 'widgets/update-banner/hooks/useChunkErrorHandler';

function UpdateBannerContainer() {
  const { updateAvailable, dismiss, reload } = useVersionCheck();

  useChunkErrorHandler();

  return <UpdateBanner visible={updateAvailable} onReload={reload} onDismiss={dismiss} />;
}

export default UpdateBannerContainer;
